import { TooltipHintProps } from './index';
import { Colors } from '../../common/Colors';
import { helperViewHintList } from '../../helpers';

export function getContentStyle(view: TooltipHintProps['view']) {
  return {
    cursor: 'auto',
    zIndex: 1000,
    lineHeight: '1.3',
    fontSize: '1.5rem',
    color: Colors.white,
    textAlign: 'center',
    backgroundColor: helperViewHintList[view!].backgroundColor,
    border: 0,
    borderRadius: '1rem',
    boxShadow: 'none',
    // TODO: пока так. Но в идеале потом выпилить этот компонент
    filter: `drop-shadow(0 1px 0 rgba(0,0,0,0.1))`,
    width: 'auto'
  };
}

export function getArrowStyle(view: TooltipHintProps['view']) {
  return {
    width: '1.4rem',
    height: '1.4rem',
    margin: '-0.7rem',
    backgroundColor: helperViewHintList[view!].backgroundColor,
    boxShadow: 'none'
  };
}

export const overlayStyle = {
  cursor: 'auto',
  zIndex: 999,
  opacity: 0,
  animationName: 'none'
};

export const TooltipAnimation = {
  transform: 'translateY(0)',
  animationDuration: '0.3s'
};
